__turbopack_context__.v({
  "container": "ErrorPageLayout-module__udxQIW__container",
  "logo": "ErrorPageLayout-module__udxQIW__logo",
  "main": "ErrorPageLayout-module__udxQIW__main",
});
